import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog } from '../../utilities/styles';
export class AllInSession extends LitElement {
    static properties = {
        sessionTimeout: { type: Number },
        sessionTimeoutMessage: { type: String },
        sessionAlmostTimeoutMessage: { type: String },
        restUrl: { type: String },
        nonce: { type: String }
    };
    constructor() {
        super();
        if (!this.sessionTimeout) {
            this.sessionTimeout = 60 * 60 * 1000;
        }
    }
    get dialog() {
        return this.renderRoot.querySelector('dialog');
    }
    connectedCallback() {
        super.connectedCallback();
        this._startSessionTimer();
        window.addEventListener('refresh-user-session', this._refreshUserSession.bind(this));
    }
    render() {
        // let redirect = window.location.href;
        // redirect = encodeURIComponent(redirect);
        return html `\n            <dialog id="session-expired"><h2>Session expired</h2>\n                <p>${this.sessionTimeoutMessage || `Your session has expired. Please log in again.`}</p>\n                <button class="button" @click="${this._loginNow}">Log in</button>\n            </dialog>\n            \n            <dialog id="session-almost-expired">\n                <h2>Session expiring soon</h2>\n                <p>${this.sessionAlmostTimeoutMessage || `Your session is about to expire soon, please save any unsaved work to prevent losing it permanently`}</p>\n                <div class="button-group">\n                    <button class="button" @click="${this._stayLoggedIn}">Stay logged in</button>\n                    <button class="button secondary" @click="${this._logoutNow}">Log out now</button>\n                </div>\n            </dialog>\n        `;
    }
    // _startSessionTimer(){
    //     // const expireTime = this.sessionTimeout; 
    //     // const warningOffset = 10 * 60 * 1000;
    //     const expireTime = 1 * 60 * 1000; 
    //     const warningOffset = 30 * 1000;
    //     // Warning timer
    //     this._warningTimer = setTimeout(() => {
    //         const warningDialog = this.renderRoot.querySelector('#session-almost-expired');
    //         if (warningDialog) warningDialog.showModal();
    //     }, expireTime - warningOffset);
    //     this._sessionTimer = setTimeout(() => {
    //         const expiredDialog = this.renderRoot.querySelector('#session-expired');
    //         if (expiredDialog) expiredDialog.showModal();
    //         let htmlDoc = this.renderRoot.host.closest('html');
    //         htmlDoc.cookie = "allin-uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    //     }, this.sessionTimeout);
    // }
    /* AN OLD STARTSESSIONTIMER THAT FAILED COUNTING TIME ONCE USER COMPUTER STAYS IDLE */
    // _startSessionTimer() {
    //     const expireTime = this.sessionTimeout;
    //     const warningOffset = 10 * 60 * 1000;
    //     // clear any existing timers
    //     clearTimeout(this._warningTimer);
    //     clearTimeout(this._sessionTimer);
    //     // show warning here
    //     this._warningTimer = setTimeout(() => {
    //         const warningDialog = this.renderRoot.querySelector('#session-almost-expired');
    //         warningDialog?.showModal();
    //     }, expireTime - warningOffset);
    //     // expire session AFTER full time
    //     this._sessionTimer = setTimeout(() => {
    //         const warningDialog = this.renderRoot.querySelector('#session-almost-expired');
    //         if (warningDialog?.open) warningDialog.close();
    //         const expiredDialog = this.renderRoot.querySelector('#session-expired');
    //         expiredDialog?.showModal();
    //         document.cookie = "allin_uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    //     }, expireTime);
    // }
    /* A NEW  STARTSESSIONTIMER THAT KEEPS COUNTING THE TIME EVEN WHEN USER COMPUTER STAYS IDLE => It relies on Date.now() which is more resilient */
    _startSessionTimer() {
        const expireTime = this.sessionTimeout;
        const warningOffset = 10 * 60 * 1000;
        clearTimeout(this._warningTimer);
        clearTimeout(this._sessionTimer);
        // Store absolute timestamps
        this._sessionExpiresAt = Date.now() + expireTime;
        this._sessionWarningAt = this._sessionExpiresAt - warningOffset;
        const checkSession = () => {
            const now = Date.now();
            const warningDialog = this.renderRoot.querySelector('#session-almost-expired');
            const expiredDialog = this.renderRoot.querySelector('#session-expired');
            if (now >= this._sessionExpiresAt) {
                // Session has expired
                if (warningDialog?.open) {
                    warningDialog.close();
                }
                if (expiredDialog && !expiredDialog.open) {
                    expiredDialog.showModal();
                }
                document.cookie = "allin_uid=; Max-Age=0; path=/";
                return;
            }
            if (now >= this._sessionWarningAt) {
                // Session is within warning period
                if (warningDialog && !warningDialog.open) {
                    warningDialog.showModal();
                }
                // Schedule another check for expiry
                this._sessionTimer = setTimeout(checkSession, Math.max(0, this._sessionExpiresAt - Date.now()));
                return;
            }
            // Still before warning period
            this._warningTimer = setTimeout(checkSession, Math.max(0, this._sessionWarningAt - Date.now()));
        };
        checkSession();
    }
    _refreshUserSession() {
        clearTimeout(this._sessionTimer);
        this._startSessionTimer();
        this._refreshRemoteUserSession();
    }
    async _refreshRemoteUserSession() {
        try {
            let response = await fetch(this.restUrl, {
                method: 'GET',
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
        }
        catch (error) {
            console.error('There was a problem with the fetch operation:', error);
        }
    }
    _closeWarning() {
        const dialog = this.renderRoot.querySelector('#session-almost-expired');
        if (dialog)
            dialog.close();
    }
    _stayLoggedIn() {
        this._closeWarning();
        this._refreshUserSession();
    }
    _logoutNow() {
        this._closeWarning();
        //stop session timers
        clearTimeout(this._warningTimer);
        clearTimeout(this._sessionTimer);
        window.location.href = '/logout/';
    }
    // _loginNow() {
    //     //this._logoutNow();  // ended up using logout trick here because window.location.href = '/login/' kept reloading nonstop and not sure how to stop it.
    //     this._closeWarning();
    //     //stop session timers
    //     clearTimeout(this._warningTimer);
    //     clearTimeout(this._sessionTimer);
    //     document.cookie = "allin-uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
    //     window.location.href = '/login/';
    // }
    _loginNow() {
        this._closeWarning();
        clearTimeout(this._warningTimer);
        clearTimeout(this._sessionTimer);
        document.cookie = "allin_uid=; Max-Age=0; path=/";
        const redirect = encodeURIComponent(window.location.href);
        window.location.href = `/login/?redirect_to=${redirect}`;
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        css `
            dialog{
                padding:2rem;
            }
            a{
                margin-top:3rem;
                display: block;
                text-align: center;
            }
        `
    ];
}
